import React from 'react';

export function ReportsFilterBar({ filters, options, onChange }) {
  const set = (patch) => onChange({ ...filters, ...patch });
  const isCustom = filters.dateKey === 'custom';
  return (
    <div className="dashboard-filters">
      <input type="text" placeholder="Search name…" aria-label="Search name"
        value={filters.name || ''} onChange={(e) => set({ name: e.target.value })} />
      <select aria-label="Team Lead" value={filters.teamLead || ''} onChange={(e) => set({ teamLead: e.target.value || null })}>
        <option value="">All team leads</option>
        {options.teamLeads.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
      </select>
      <select aria-label="Country" value={filters.countryId || ''} onChange={(e) => set({ countryId: e.target.value || null })}>
        <option value="">All countries</option>
        {options.countries.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
      <select aria-label="Dates" value={filters.dateKey || ''} onChange={(e) => set({ dateKey: e.target.value || null })}>
        <option value="">All dates</option>
        <option value="this-week">This week</option>
        <option value="last-week">Last week</option>
        <option value="this-month">This month</option>
        <option value="this-quarter">This quarter</option>
        <option value="this-year">This year</option>
        <option value="custom">Custom dates</option>
      </select>
      {isCustom && (
        <>
          <input type="date" aria-label="From date" value={filters.customFrom || ''}
            onChange={(e) => set({ customFrom: e.target.value || null })} />
          <input type="date" aria-label="To date" value={filters.customTo || ''}
            onChange={(e) => set({ customTo: e.target.value || null })} />
        </>
      )}
    </div>
  );
}
